<template>
  <div class="nx-players-lineup-wrapper">
    <label class="v-label--active v-label theme--light mb-2 d-inline-block" v-if="label">
      {{ label }}
    </label>
    <div>
      <v-btn @click="openLineupDialog" v-if="!disableLineupEditor">
        Editar alineación
        <v-icon right>sports_soccer</v-icon>
      </v-btn>
    </div>
    <div class="elevation-1">
      <div class="v-table__overflow">
        <table class="v-datatable v-table theme--light">
          <thead>
          <tr>
            <td>{{ $t('message.form.fields.playerNumber') }}</td>
            <td>{{ $t('message.form.fields.playerName') }}</td>
            <td>{{ $t('message.form.fields.inStartingEleven') }}</td>
            <td v-if="showStatusColumn">{{ $t('message.form.fields.state') }}</td>
            <td v-if="showPositionColumn">{{ $t('message.form.fields.playerPosition') }}</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(player, index) in computedPlayers" :key="player.playerId">
            <td class="py-2">
              <v-text-field
                hide-details solo flat type="number"
                :label="$t('message.form.fields.playerNumber')"
                :value="player.playerNumber"
                @input="update(index, 'playerNumber', $event)"
              ></v-text-field>
            </td>
            <td class="py-2">
              <p class="body-2 ma-0">{{ player.playerName }}</p>
              <p class="caption text--secondary ma-0">{{ player.teamName }}</p>
            </td>
            <td class="pt-3">
              <v-checkbox
                :input-value="player.inStartingEleven"
                @change="update(index, 'inStartingEleven', $event)"
              ></v-checkbox>
            </td>
            <td class="py-2" v-if="showStatusColumn">
              <v-autocomplete
                hide-details solo flat
                :label="$t('message.form.fields.state')"
                :items="statusOptions"
                :value="player.state"
                @input="update(index, 'state', $event)"
              ></v-autocomplete>
            </td>
            <td class="py-2" v-if="showPositionColumn">
              <v-autocomplete
                v-if="showPositionSelector(player)"
                hide-details solo flat
                :label="$t('message.form.fields.playerPosition')"
                :items="positionOptions"
                :value="player.position"
                @input="update(index, 'position', $event)"
              ></v-autocomplete>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <nx-live-football-match-lineup
      v-if="lineupDialogState.render"
      :active="lineupDialogState.active"
      :players="computedPlayers"
      @dismiss="closeLineupDialog"
      @input="updateLineup"
    ></nx-live-football-match-lineup>
  </div>
</template>

<script>
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import NxLiveFootballMatchLineup from '@/modules/live/LiveFootballMatchLineup';

export default {
  name: 'nx-live-football-match-players',
  extends: {},
  mixins: [],
  components: { NxLiveFootballMatchLineup },
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    players: {
      type: Array,
      required: false,
    },
    playersAttribute: {
      type: String,
      required: false,
      default: 'matchPlayers',
    },
    positionOptions: {
      type: Array,
      required: false,
    },
    statusOptions: {
      type: Array,
      required: false,
    },
    playingStatusValues: {
      type: Array,
      required: false,
    },
    disableLineupEditor: Boolean,
  },
  data() {
    return {
      lineupDialogState: { render: false, active: false },
    };
  },
  computed: {
    computedPlayers() {
      if (Array.isArray(this.players) && this.players.length > 0) {
        return this.players;
      }
      const contentEditorPlayers = get(this.$store.state, `content.editor.channels.master.${this.playersAttribute}`);
      if (Array.isArray(contentEditorPlayers) && contentEditorPlayers.length > 0) {
        return contentEditorPlayers;
      }
      return false;
    },
    showStatusColumn() {
      return Array.isArray(this.statusOptions) && this.statusOptions.length > 0;
    },
    showPositionColumn() {
      return this.showStatusColumn
        && Array.isArray(this.positionOptions)
        && this.positionOptions.length > 0;
    },
  },
  methods: {
    showPositionSelector(player) {
      if (!Array.isArray(this.playingStatusValues)
        || this.playingStatusValues.length === 0) {
        return true;
      }
      return this.playingStatusValues.includes(player.state);
    },
    update(index, field, value) {
      const draft = cloneDeep(this.computedPlayers);
      draft[index][field] = value;
      this.$emit('input', draft);
    },
    openLineupDialog() {
      this.lineupDialogState.render = true;
      this.$nextTick(() => {
        this.lineupDialogState.active = true;
      });
    },
    closeLineupDialog() {
      this.lineupDialogState.active = false;
      this.$nextTick(() => {
        this.lineupDialogState.render = false;
      });
    },
    updateLineup(draft) {
      this.$emit('input', draft);
      this.closeLineupDialog();
    },
  },
  beforeCreate() {
  },
  mounted() {
  },
};
</script>
